import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-grow-search',
    templateUrl: './grow-search.component.html',
    styleUrls: ['./grow-search.component.scss'],
})
export class GrowSearchComponent implements OnInit {
    @ViewChild('searchInputElement') searchInputElement: ElementRef<HTMLInputElement>;

    @Output()
    searchEvent = new EventEmitter<string>();

    @Output()
    currentSearchValue = new EventEmitter<string>();

    @Input()
    searchTerm: string;

    @Input()
    isExpanded: boolean = true;

    isDropdownVisible = false;
    searchInput = new FormControl('');
    lastSearches: string[];

    constructor() {}

    async ngOnInit(): Promise<void> {
        this.lastSearches = JSON.parse(localStorage.getItem('growSearchHistory')) || [];

        if (this.searchTerm) {
            this.searchInput.setValue(this.searchTerm);
        }
    }

    onFocus(): void {
        if (this.isExpanded) {
            this.isDropdownVisible = true;
        }
    }

    onBlur(): void {
        setTimeout(() => {
            // Delay must outlast click/mousedown so history items remain interactive
            this.isDropdownVisible = false;
        }, 400);
    }

    removeLastSearch(searchTerm: string, event?: MouseEvent): void {
        if (event) {
            event.preventDefault(); // prevent input blur
            event.stopPropagation();
        }

        const index = this.lastSearches.indexOf(searchTerm);
        if (index > -1) {
            this.lastSearches.splice(index, 1);
            localStorage.setItem('growSearchHistory', JSON.stringify(this.lastSearches));
        }

        this.searchInputElement?.nativeElement.focus();
    }

    search(searchInputValue: string): void {
        const trimedSearchInputValue = searchInputValue.trim();

        this.lastSearches = JSON.parse(localStorage.getItem('growSearchHistory')) || [];

        this.searchInput.setValue(trimedSearchInputValue);
        this.currentSearchValue.emit(this.searchInput.value);

        if (trimedSearchInputValue && this.isExpanded) {
            const existingIndex = this.lastSearches.indexOf(trimedSearchInputValue);
            if (existingIndex > -1) {
                this.lastSearches.splice(existingIndex, 1);
            }

            // add search term on first position in array
            this.lastSearches.unshift(trimedSearchInputValue);

            // remove last search term
            if (this.lastSearches.length > 5) {
                this.lastSearches.pop();
            }

            // remember last search terms in local storage
            localStorage.setItem('growSearchHistory', JSON.stringify(this.lastSearches));
        }

        this.searchEvent.emit(trimedSearchInputValue);
        this.isDropdownVisible = false;
    }
}
